import React, { useState } from "react";
import { getSession } from "../redux/actions/authActions";
import "./db.scss";
import SideProfileIcon from "../../assets/SideProfileIcon";

export const Header = ({ pageTitle, icon }) => {
  const { userFirstname, user_last_name, role, user_profile_id } = getSession();
  // State to manage the visibility of the search input
  const [showUserDetails, setShowUserDetails] = useState(false);

  return (
    <div className=" bg-white border-b border-[#E7E7E9] sticky top-0 z-30 w-full hidden sm:block">
      <div className="w-full h-[74px] px-8 flex items-center justify-between">
        <h5 className="pl-10 tab:pl-0 text-[#4A4E5A] font-normal text-sm gap-[6px] flex items-center mb-0">
          {icon}
          {pageTitle}
        </h5>

        <div className="flex">
          <div className="flex items-center relative">
            <p className="user-name mb-0 font-semibold ">
              {userFirstname + " " + user_last_name.charAt(0) + "( " + role + " )"}
            </p>
          </div>
          {userFirstname && (
            <div className="bg-[#DBDBDB] border-[#E7E7E9] p-2.5 ml-2 rounded-full drop-shadow-md shadow-[#A4ACB933]">
              <SideProfileIcon />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
